module.exports = "/_next/static/chunks/fonts/waves-d9deabf31292e11d483d8ec4e8ffcf80.svg";